{
    "component-card-search-list.empty-state.title.non-final": "<strong>Depoyu bir yazılım bileşenine bağlayın</strong>",
    "component-card.add-chat-channel": "Sohbet kanalı ekle",
    "component-card.chat-channels": "Sohbet kanalları",
    "component-card.expander.show-more-link": "{formattedCount} bileşen daha göster"
}
